import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import { RootState } from '@/types/store'

import gardens from '@/store/gardens'
import snackbars from '@/store/snackbars'
import sw from '@/store/sw'

import { auth } from '@/firebase'
import { id } from '@/types/models'

Vue.use(Vuex)

// export default new Vuex.Store({
const store: StoreOptions<RootState> = {
  modules: {
    gardens,

    snackbars,
    sw,
  },
  state: {
    user: undefined,
    isUserLoading: true,
  },
  getters: {
    user: (state) => state.user,
    isUserLoading: (state) => state.isUserLoading,

    gardens: (state, getters) => getters['gardens/all'],
    garden: (state, getters) => (gardenId: id) =>
      getters['gardens/find'](gardenId), // state.gardens.find((g: GardenDefinition) => g.id === gardenId),

    images: (state, getters) => getters['gardens/images/all'],

    // plants: (state, getters) => getters['plants/plants'],
    // plant: (state, getters) => (plantId: string) => getters['plants/plant'](plantId),

    // harvests: (state, getters) => getters['plants/harvests/harvests'],

    // log: (state, getters) => getters['log/log'],
  },
  mutations: {
    SET_USER(state, payload) {
      state.isUserLoading = false
      state.user = payload
    },
  },
  actions: {
    SET_USER({ dispatch, commit }, payload) {
      if (payload == null) {
        dispatch('unbindAll')
      } else {
        dispatch('bindAll', payload.uid)
      }

      commit('SET_USER', payload)
    },
    registerUser(context, payload) {
      return new Promise((resolve, reject) => {
        auth
          .createUserWithEmailAndPassword(payload.email, payload.password)
          .then((res) => {
            return res.user
            // return res?.user?.updateProfile({
            //   displayName: payload.displayName
            // });
          })
          .then((res) => resolve(res))
          .catch((err) => reject(err))
      })
    },
    login(context, payload) {
      return auth.signInWithEmailAndPassword(payload.email, payload.password)
    },
    logout() {
      return auth.signOut()
    },

    bindAll({ dispatch }, userId: id) {
      dispatch('gardens/bind', userId)
    },
    unbindAll({ dispatch }) {
      dispatch('gardens/unbind')
      dispatch('gardens/images/unbind')
      dispatch('gardens/log/unbind')
      dispatch('gardens/plants/unbind')
      dispatch('gardens/plants/harvests/unbind')
    },
  },
}

export default new Vuex.Store<RootState>(store)
